import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-3">
              乳交完全指南
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              致力于为成年伴侣提供专业、负责任的亲密关系教育内容。所有内容仅供18岁以上成年人参考。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              关于本站
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                >
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              免责声明
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              本站内容仅供教育和参考目的，不构成医疗或心理咨询建议。如有健康疑虑，请咨询专业医师。本网站仅限18岁以上成年人访问。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 乳交完全指南。仅供18岁以上成年人。
          </p>
          <p className="text-xs text-background-400">
            理性探索 · 健康沟通 · 尊重彼此
          </p>
        </div>
      </div>
    </footer>
  );
}